import { Component } from "react";
import { withRouter } from "../hock/withRouter";
import "../css/Login.css";
import Swal from "sweetalert2";
import * as common from "../common/common.js";

class Login extends Component {
  apiUrl = process.env.REACT_APP_API_URL;

  api = {
    login: this.apiUrl + "/login_action",
    auth: this.apiUrl + "/authentication",
  };

  state = {
    userId: "",
    password: "",
    auth: true,
  };

  componentDidMount() {
    this.handle.authenticationCheck();
  }

  handle = {
    authenticationCheck: async () => {
      try {
        //API 호출 등을 통해 로그인 여부 확인
        const response = await fetch(this.api.auth, {
          method: "GET",
          credentials: "include", // 이 옵션을 추가
        });

        const data = await response.json();

        // 임시로 로그인 여부를 true로 설정
        const isLoggedIn = data.code === "200" ? true : false;

        this.setState(
          {
            auth: isLoggedIn,
          },
          () => {
            if (isLoggedIn) {
              this.props.navigate("/equipment", { replace: true });
            } else {
              this.props.navigate("/", { replace: true });
            }
          }
        );
      } catch (error) {
        Swal.fire({
          text: "서버 오류가 발생하였습니다.",
          icon: "error",
        }).then(() => {
          this.props.navigate("/", { replace: true });
        });
      }
    },
    loginBtnClick: async () => {
      if (
        common.isEmpty(this.state.userId) ||
        common.isEmpty(this.state.password)
      ) {
        Swal.fire({
          text: "아이디 또는 비밀번호를 입력하세요.",
          icon: "warning",
        });
        return;
      }

      const param = {
        userId: this.state.userId,
        password: this.state.password,
      };

      try {
        const response = await fetch(this.api.login, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(param),
          credentials: "include", // 이 옵션을 추가
        });

        const data = await response.json();

        if (data.code === "500" && data.message === "noUser") {
          Swal.fire({
            text: "아이디 또는 비밀번호가 일치하지 않습니다.",
            icon: "warning",
          });
          return;
        }
        this.props.navigate("/equipment", { replace: true });
      } catch (error) {
        console.log(error);
        Swal.fire({
          text: "서버 오류가 발생하였습니다.",
          icon: "error",
        });
      }
    },
    userIdChange: (event) => {
      this.setState({
        userId: event.target.value,
      });
    },
    passwordChange: (event) => {
      this.setState({
        password: event.target.value,
      });
    },
  };

  render() {
    return (
      <div>
        {this.state.auth === false ? (
          <div className="container">
            <div className="login-container">
              <h2 className="logo">동언테크</h2>
              <div className="login-form">
                <input
                  type="text"
                  className="form-input"
                  onChange={this.handle.userIdChange}
                  placeholder="아이디"
                />
                <input
                  type="password"
                  className="form-input"
                  onChange={this.handle.passwordChange}
                  placeholder="비밀번호"
                />
                <button
                  type="button"
                  onClick={this.handle.loginBtnClick}
                  className="form-submit"
                >
                  로그인
                </button>
              </div>
            </div>
          </div>
        ) : (
          <></>
        )}
      </div>
    );
  }
}

export default withRouter(Login);
